import react, { useReducer, useMemo, useContext, useEffect } from 'react'
import { lockedReducer } from '../../Utils/reducers'
import { Box, FormControl, InputLabel, Select, MenuItem, TextField, IconButton, Tooltip } from '@mui/material'
import Table from '../../Table'
import dayjs from 'dayjs'
import {  useTheme } from '@mui/material/styles';
import ColorButton from '../../Buttons/ColorButton'
import { externalComponent } from '../../AppRoutes'
import { api } from '../../../services/api'
import EditIcon from '@mui/icons-material/Edit';
import CancelIcon from '@mui/icons-material/Cancel';
import toast from 'react-hot-toast'
//import ConfirmationDialog from '../../Information/ConfirmationDialog'
import ConfirmationDialog from '../../Utils/ConfirmationDialog'
import EditSellers from './edit'
import { formatPercentage } from '../../Utils/IntegerOnly'

const getcolumns = (state, setState) => {
    const rowmap = Object.fromEntries(state.users.map(row => ([row.id, row])))
    const columns = []
    columns.push({ field: 'user_id', headerName: 'Usuário', flex: 1, renderCell: ({ value }) => rowmap[value]?.username })
    columns.push({ field: 'seller', headerName: 'Vendedor', flex: 1, renderCell: ({ value }) => value?.label })
    columns.push({ field: 'comission', headerName: 'Comissão máxima', flex: 1, renderCell: ({ value }) => formatPercentage(value) })
    columns.push({
        field: 'actions', headerName: 'Ações', width: 100,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Editar'><IconButton onClick={() => { setState({ edit: props.row }) }}><EditIcon /></IconButton></Tooltip>
                    <Tooltip title='Excluir'><IconButton onClick={() => { setState({ delete: props.row }) }}><CancelIcon /></IconButton></Tooltip>
                </Box >
            )
        }
    }
    )

    return columns
}

const requestUsers = async (state, setState, setLoader, returnValue = false) => {

    let url = `/representantes/?status=true`

    setLoader(true)
    const res = await api.get(url)
    if (res.status === 200) {
        if (returnValue) return res.data
        setState({
            rows: res.data
        })
    } else if (res.status === 400) {
        toast.error(res.data)
    }

    setLoader(false)
    return []
}

const requestSellers = async (state, setState, setLoader, returnValue = false) => {

    let url = `/vendedores/`

    setLoader(true)
    const res = await api.get(url)
    if (res.status === 200) {
        if (returnValue) return res.data
        setState({
            rows: res.data
        })
    } else if (res.status === 400) {
        toast.error(res.data)
    }

    setLoader(false)
    return []
}

const initialize = async (state, setState, setLoader) => {

    setLoader(true)
    const [users, sellers] = await Promise.all([requestUsers(state, setState, () => { }, true), requestSellers(state, setState, () => { }, true)])
    setState({
        users: users,
        rows: sellers
    })
    setLoader(false)
}


const submitSellers = async (state, setState, setLoader) => {
    setLoader(true)

    let res = null

    if (state.id)
        res = await api.patch('/vendedores/' + state.id + '/', state)
    else
        res = await api.post('/vendedores/', state)
    if ([200, 201].includes(res.status)) {
        setState({ edit: false })
        toast.success('Vendedor salvo com sucesso')
    } else {
        toast.error('Houve um erro para salvar os dados')
    }

    setLoader(false)
}

const deleteSellers = async (state, setState, setLoader) => {
    setLoader(true)


    const res = await api.delete('/vendedores/' + state.id + '/')

    if ([204].includes(res.status)) {
        setState({ delete: false })
        toast.success('Vendedor removido com sucesso')
    } else {
        toast.error('Houve um erro para remover os dados')
    }

    setLoader(false)
}


const Sellers = () => {

    const { setLoader } = useContext(externalComponent)

    const [state, setState] = useReducer(lockedReducer, {
        edit: null,
        delete: null,
        rows: [],
        users: []
    })

    useEffect(() => {
        initialize(state, setState, setLoader)
    }, [])

    return (
        <>
            {state.edit &&
                <EditSellers
                    data={state.edit}
                    sellers={state.rows.map(row => row.seller?.id)}
                    submit={(data) => {
                        submitSellers(data, setState, setLoader).then(() => requestSellers(state, setState, setLoader));
                    }}
                    handleClose={() => setState({ edit: null })}
                    users={state.users}
                />}
            {state.delete &&
                <ConfirmationDialog
                    open={true}
                    content={<>Deseja remover o vendedor {state.users.find(user=> user.id===state.delete.seller)?.username}?</>}
                    onConfirm={() => { deleteSellers(state.delete, setState, setLoader).then(()=> requestSellers(state, setState, setLoader)) }}
                    handleClose={() => setState({ delete: null })}
                />}

            <Box className='nfsentrada-mainframe'>
                <Box sx={{ flex: 1, overflow: 'hidden' }}>
                    <Table
                        paginationMode='client'
                        className='contabil-grid'
                        rows={state.rows}
                        columns={useMemo(() => getcolumns(state, setState), [state.rows, state.edit])}
                        pagination={false}
                        disableRowSelectionOnClick
                        toolbar
                        slots={{
                            filterComponent: true,
                            columnComponent: true,
                            addComponent: () => setState({ edit: {} })
                        }}
                        density='compact'
                        rowHeight={30}
                    />
                </Box>
            </Box>
        </>
    )

}

export default Sellers